<template>
  <div
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid,
      statusNoBorder: fieldStyle == 'style2-wap'
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-checkbox-list-wap img-list">
      <div
        class="opts"
        v-for="(o, i) in fieldObj.listOptions"
        :key="o.optionId"
        :class="{
          'item-other': o.isOther == 1
        }"
      >
        <div class="opt-img" v-if="o.picUrl">
          <img
            :src="o.picUrl"
            alt=""
            @click="
              showImg(
                o.picUrl,
                o.optionValue,
                fieldObj.options[i].optionDescText ||
                  fieldObj.options[i].optionDescHrefText,
                fieldObj.options[i].optionDescHref
              )
            "
          />
        </div>
        <a-checkbox
          class="m-checkbox-item"
          @change="handleChange"
          :value="o.optionId"
          :disabled="fieldObj.disabled || o.disabled"
          v-model="o.checked"
        >
          {{ o.optionLabel || o.optionValue }}
        </a-checkbox>
        <input
          class="otherInput"
          v-if="o.isOther == 1 && o.checked"
          type="text"
          v-model="o.otherValue"
          placeholder="请输入"
          @blur="inputBlur($event, o)"
        />
        <div
          class="u-reg-err-tips"
          v-if="
            o.checked &&
              o.otherisFillIn == 1 &&
              o.otherIsRequire == 1 &&
              !o.otherValue
          "
        >
          请填写
        </div>
      </div>
    </div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
    <div class="img-view" v-if="isShow">
      <div class="view-box view-box-wap">
        <div class="title">{{ title }}</div>
        <div class="img-box">
          <div class="close" @click="close">&times;</div>
          <img :src="src" alt="" />
        </div>
        <div class="desc" v-if="!href && desc" :class="{
          'desc-left': desc.indexOf('&|&') > -1
        }">{{ desc.replace('&|&','') }}</div>
        <div class="desc" v-if="href">
          <a :href="href">{{ desc }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkboxImgMixin from "../../field/new-fields/checkbox-img";
export default {
  name: "sk-checkbox-img-wap",
  mixins: [checkboxImgMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
.otherInput {
  display: block;
  width: calc(100% - 24px);
  margin-top: 4px;
  margin-left: 24px;
  box-sizing: border-box;
}
.otherInput::placeholder {
  color: #d9d9d9;
}
.otherInput:disabled {
  cursor: not-allowed;
  background-color: #fff;
}
.u-reg-err-tips {
  padding-left: 24px;
}
.m-checkbox-item {
  display: flex;
  align-items: flex-start;
}
::v-deep .ant-checkbox-wrapper .ant-checkbox {
  top: 0.1em;
}
</style>
